import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../presentation/pages/authPages/Login";
import ResetPasswordPage from "../presentation/pages/authPages/ResetPasswordPage";
import Dashboard from "../presentation/pages/dashboard/Dashboard";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import { useAuth } from "../presentation/hooks/useAuth";
import OverviewPage from "../presentation/pages/dashboard/OverviewPage";
import ProductsPage from "../presentation/pages/dashboard/ProductsPage";
import TroubleshootPage from "../presentation/pages/dashboard/TroubleshootPage";
import SecurityPage from "../presentation/pages/dashboard/SecurityPage";
import AlertPage from "../presentation/pages/dashboard/AlertPage";
import Settings from "../presentation/pages/settingsPage/sttings";
import ChangePasswordPage from "../presentation/pages/settingsPage/changePasswordPage";
import InvoicePage from "../presentation/pages/invoicePages/invoicePage";
import InvoiceDetail from "../presentation/pages/invoicePages/InvoiceDetail";
import ProductDetailPage from "../presentation/pages/ProductsInfosPages/productDetailPage";
import BackupPage from "../presentation/pages/dashboard/backupPage";
import MonthlyReportPage from "../presentation/pages/dashboard/monthlyReportPage";

const AppRoutes = () => {
  const { loading, authChecked } = useAuth();

  if (loading || !authChecked) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg-main">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary-cyan border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-400 text-lg">Loading your session...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        }
      />

      {/* Protected Dashboard with nested routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard/products" replace />} />
        <Route path="overview" element={<OverviewPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="troubleshoot" element={<TroubleshootPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="alert" element={<AlertPage />} />
        <Route path="financial" element={<InvoicePage />} />
        <Route path="backups" element={<BackupPage />} />
        <Route path="monthly-report" element={<MonthlyReportPage />} />
      </Route>

      <Route path="/" element={<Navigate to="/login" replace />} />

      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        }
      />

      <Route
        path="/invoiceDetail/:id"
        element={
          <ProtectedRoute>
            <InvoiceDetail />
          </ProtectedRoute>
        }
      />

      {/* NEW DYNAMIC ROUTES for ProductDetail with VM and Tag support */}
      <Route
        path="/productDetail/vm/:vmName/:tab"
        element={
          <ProtectedRoute>
            <ProductDetailPage />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/productDetail/tag/:tagName/:tab"
        element={
          <ProtectedRoute>
            <ProductDetailPage />
          </ProtectedRoute>
        }
      />

      {/* Legacy route for backward compatibility */}
      <Route
        path="/productDetail"
        element={
          <ProtectedRoute>
            <ProductDetailPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/changePassword"
        element={
          <ProtectedRoute>
            <ChangePasswordPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;